import { Link } from "react-router-dom";

export interface CrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: CrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
          {index < items.length - 1 && (
            <span className="flex h-4 w-4 items-center justify-center text-foreground-300">
              <i className="ri-arrow-right-s-line text-base" />
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}